import { useId } from "react";
import classNames from "classnames";
import { RecognitionMethod } from "@common/types/domains/accounting/schedule";
import { HStack } from "@design-system/HStack/HStack";
import { VStack } from "@design-system/VStack/VStack";
import { usePortalContainer } from "@design-system/overlay/OverlayContainerContext";
import { DrawerInlineRow } from "./DrawerInlineRow";
import { ScheduleManualLayout } from "./scheduleManualLayout";
import { ScheduleRowTerm, ScheduleTermControls } from "./ScheduleTermControls";
import drawerStyles from "../ScheduleDrawer.module.scss";
import styles from "./ScheduleManualModal.module.scss";

const LABEL = "Service period";

interface ScheduleAccruedTermFieldProps {
    term: ScheduleRowTerm;
    onTermChange: (term: ScheduleRowTerm) => void;
    method: RecognitionMethod;
    summary: string | null;
    layout: ScheduleManualLayout;
}

export const ScheduleAccruedTermField = ({
    term,
    onTermChange,
    method,
    summary,
    layout,
}: ScheduleAccruedTermFieldProps) => {
    const portalContainer = usePortalContainer();
    const labelId = useId();
    const controls = (
        <HStack gap={6} align="center" wrap>
            <ScheduleTermControls
                term={term}
                method={method}
                portalContainer={portalContainer}
                lengthAriaLabelledBy={labelId}
                unitAriaLabel="Service period unit"
                onTermChange={onTermChange}
            />
            {summary && <span className={styles.connector}>{summary}</span>}
        </HStack>
    );

    if (layout === "drawer") {
        return (
            <div
                className={classNames(
                    drawerStyles.card,
                    drawerStyles.cardStack,
                )}
            >
                <DrawerInlineRow label={LABEL} labelId={labelId}>
                    {controls}
                </DrawerInlineRow>
            </div>
        );
    }

    return (
        <VStack gap={6} align="start">
            <span id={labelId} className={styles.fieldLabel}>
                {LABEL}
            </span>
            {controls}
        </VStack>
    );
};
